import { combineSlices } from "@reduxjs/toolkit"

import { businessModeReducer } from "@/features/business-mode"

import { prohibitedWordsReducer } from "@/entities/channel/security-rule"

import { apiSlice, writeScopeReducer } from "@/shared/api"

export interface LazyLoadedSlices {}

export const rootReducer = combineSlices(apiSlice, {
  prohibitedWords: prohibitedWordsReducer,
  businessMode: businessModeReducer,
  settingsWriteScope: writeScopeReducer
}).withLazyLoadedSlices<LazyLoadedSlices>()
